import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'subtle';
}

const Badge: React.FC<BadgeProps> = ({ children, variant = 'default' }) => {
  const base = 'inline-flex items-center border font-mono tracking-wider transition-colors duration-150 cursor-default';
  const variants = {
    default:
      'px-2 py-1 text-[11px] border-neutral-300 dark:border-neutral-700 text-neutral-700 dark:text-neutral-300 hover:border-accent hover:text-neutral-900 dark:hover:text-neutral-100',
    subtle:
      'px-2 py-0.5 text-[10px] border-neutral-200 dark:border-neutral-800 text-neutral-500 dark:text-neutral-500 hover:border-neutral-400 dark:hover:border-neutral-600 hover:text-neutral-700 dark:hover:text-neutral-300',
  };
  return <span className={`${base} ${variants[variant]}`}>{children}</span>;
};

export default Badge;
